import Vue from 'vue'
import Vuex from 'vuex'
import { downloadFile} from '@/store/config/method'
import modules from './modules'
import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';
import Cookie from 'js-cookie'

const authStorage = new VuexPersistence({
    key: 'cdcatmajaya',
    storage: localForage,
    reducer: state => ({ auth: state.auth, 
                        master: state.master, 
                        jobseekerAccount: state.jobseekerAccount,
                        eventData: state.eventData,
                        companyData: state.companyData,
                        staffAccount: state.staffAccount,
                        modal: state.modal }),
    asyncStorage: true
})
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: false,
    modal: null,
    menuDetail: null,
    deleteConfirmation: {
      id: null,
      msg: null,
      url: null,
      moduleName: null,
      variable: null
    },
    actionConfirmation: {
      id: null,
      msg: null,
      url: null,
      moduleName: null
    },
    updateStatusConfirmation: {
      id: null,
      msg: null,
      url: null,
      moduleName: null,
      variable: null
    },
    blobData: null,
    isLoggedIn: !!Cookie.get('XSRF-TOKEN') && !!localStorage.getItem('appkey'),
    snackbar: {
      type: "success",
      text: "message",
      withclose: true,
      show: false
    },
    loading: 0,
    collapse: false,
    breadcrumb: [],

  },
  getters: {
    getDeleteConfirmation: state => state.deleteConfirmation,
    getActionConfirmation: state => state.actionConfirmation,
    getVariableDelete: state => state.deleteConfirmation.variable,
    getUpdateStatusConfirmation: state => state.updateStatusConfirmation,
    getVariableUpdateStatus: state => state.updateStatusConfirmation.variable,
    getBlobData: state => state.blobData,
    getModal: state => state.modal,
    getMenuDetail: state => state.menuDetail,
    getLoading: state => state.loading,
    getisLoggedIn: state => state.isLoggedIn,
    getSnackbar: state => state.snackbar,
    getBreadcrumb: state => state.breadcrumb,
    getCollapse: state => state.collapse,
    getIsMobile: state => state.isMobile,
  },
  actions: {
    setIsMobile({state}, value){
      state.isMobile = value < 800
    },
    setActiveTab({commit}, value){
      commit('SET_ACTIVETAB', value)
    },
    setBreadcrumb({commit}, value){
      commit('SET_BREADCRUMB', value)
    },
    setDeleteConfirmation({commit}, value){
      commit('SET_DELETE_CONFIRMATION', value)
    },
    setActionConfirmation({commit}, value){
      commit('SET_ACTION_CONFIRMATION', value)
    },
    setUpdateStatusConfirmation({commit}, value){
      commit('SET_UPDATE_STATUS_CONFIRMATION', value)
    },
    setModal({commit}, value){
      commit('SET_MODAL', value)
    },
    setMenuDetail({commit}, value){
      commit('SET_MENU_DETAIL', value)
    },
    setLoading({commit}, value){
      commit('SET_LOADING', value);
    },
    showSnackbar({commit}, {
        type = "success",
        text = "message",
        withclose = true,
        show = true
      }){
        var value ={
          type: type,
          text: text,
          withclose: withclose,
          show: show
        }
      commit('SET_SNACKBAR', value);
    },
    hideSnackbar({commit}){
        commit('HIDE_SNACKBAR');
    },
    async downloadFile({commit }, {url, type, request = {}}) 
    {
        try {
            var response = await downloadFile(url, request);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    SET_BREADCRUMB(state, value) {
      state.breadcrumb = value;
    },
    async logoutStorage({commit,state}){
      localStorage.clear()
      localForage.clear()
      const initial = modules
      Object.keys(initial).forEach(key =>  commit(`${key}/resetState`))
      state.isLoggedIn = false
    }
  },
  mutations: {
    SET_DELETE_CONFIRMATION(state, value) {
      const {id, msg, url, moduleName, variable} = value
      state.deleteConfirmation.id = id
      state.deleteConfirmation.msg = `Apakah anda akan menghapus data ${msg ? `"${msg}"` : 'ini'}?`
      state.deleteConfirmation.url = `${url}/${id}`
      state.deleteConfirmation.moduleName = moduleName
      state.deleteConfirmation.variable = variable
    },
    SET_ACTION_CONFIRMATION(state, value) {
      const {id, msg, url, moduleName} = value
      state.actionConfirmation.id = id
      state.actionConfirmation.msg = msg
      state.actionConfirmation.url = `${url}`
      state.actionConfirmation.moduleName = moduleName
    },
    SET_UPDATE_STATUS_CONFIRMATION(state, value) {
      const {id, msg, url, moduleName, variable} = value
      state.updateStatusConfirmation.id = id
      state.updateStatusConfirmation.msg = `Apakah anda akan mengubah status "${msg}"`
      state.updateStatusConfirmation.url = `${url}/${id}`
      state.updateStatusConfirmation.moduleName = moduleName
      state.updateStatusConfirmation.variable = variable
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ACTIVETAB(state, value) {
      state.activeTab = value;
    },
    SET_BREADCRUMB(state, value) {
      state.breadcrumb = value;
    },
    SET_MODAL(state, value) {
      state.modal = value;
    },
    SET_MENU_DETAIL(state, value) {
      state.menuDetail = value;
    },
    SET_SNACKBAR(state, value) {
      state.snackbar = value;
    },
    HIDE_SNACKBAR(state) {
      state.snackbar.show = false;
    },
    SET_COLLAPSE(state) {
      state.collapse = !state.collapse;
    },
    RESET_COLLAPSE(state) {
      state.collapse = false;
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
  },
  modules,
  plugins: [authStorage.plugin]
})